import { Component } from '@angular/core';
import moment from 'moment';
import { NavigationService } from './shared/navigation/navigation.service';

@Component({
  selector: 'app-secure-access-root',
  templateUrl: './secure-access-app.component.html'
})
export class SecureAccessAppComponent {
  title = 'app';


  constructor(private navigationService: NavigationService) {
  }

  get currentYear(): string {
    return moment().format('YYYY');
  }

  showHamburgerMenu(): boolean {
    return this.navigationService.showHamburgerMenu;
  }
}
